import { Component, DestroyRef, HostListener, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MsalBroadcastService } from '@azure/msal-angular';
import { EventType } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggingService } from '#services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  template: `
    <p-toast />
    <p-confirmDialog styleClass="app-dialog" />
    <router-outlet />
  `,
  styleUrl: './app.scss',
})
export class App {
  private _msalBroadcastService = inject(MsalBroadcastService);
  private _log = inject(LoggingService);
  private _destroyRef = inject(DestroyRef);

  /** Ctrl+Shift+L — downloads the in-memory log buffer as ares-app-*.log */
  @HostListener('document:keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): void {
    if (e.ctrlKey && e.shiftKey && e.key === 'L') {
      e.preventDefault();
      this._log.download();
    }
  }

  constructor() {
    // Log authentication failures for diagnostics (non-blocking)
    this._msalBroadcastService.msalSubject$
      .pipe(
        filter(event => event.eventType === EventType.LOGOUT_FAILURE),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(event => {
        this._log.error('App', 'Entra ID logout failed', event.error);
      });
  }
}
